var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-topic-selector"},[_c('FormSelectItem',{attrs:{"label":_vm.$t('release.add_at')},on:{"click":function($event){return _vm.$refs.atUserPanel.open()}}}),_c('UserSearchPanel',{ref:"atUserPanel",on:{"select":_vm.addUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }